import md5 from 'md5'

export type Group<K extends Object, V = unknown> = {
  key: K
  values: V[]
}

export function hashGroup<V, K extends Object>(values: V[], getKey: (v: V) => K[]): Group<K, V>[] {
  const map = values.reduce((acc, value) => {
    const keys = getKey(value)
    keys.forEach((key) => {
      const keyHash = md5(JSON.stringify(key) ?? 'undefined')
      if (!acc[keyHash]) {
        acc[keyHash] = {
          key,
          values: []
        }
      }
      acc[keyHash].values.push(value)
    })
    return acc
  }, {} as Record<string, Group<K, V>>)

  return Object.values(map)
}
